import type { KostnadsPoster, FinansieringsplanData } from '@shared/domain/types';
import { formatAmount } from '@shared/domain/formatters/amounts';

export function sumKostnader(k: KostnadsPoster): number {
  return k.lonn + k.eksterneTjenester + k.utstyrOgMaterialer
    + k.reiseOgMoter + k.kommunikasjon + k.andreUtgifter;
}

export function sumEgenandel(f: FinansieringsplanData): number {
  return f.egenandelKommune + f.egenandelPartner;
}

export function totalFinansiering(f: FinansieringsplanData): number {
  return sumEgenandel(f) + f.tilskuddSmartOslo;
}

export function pct(value: number, total: number): string {
  if (total === 0) return '-';
  return ((value / total) * 100).toFixed(1) + '%';
}

export function formatKr(value: number): string {
  return formatAmount(value);
}
